import { packagePickerErrorSrc17Evid2236 } from '@wix/bi-logger-premium-data/v2';
import { useBiLogger } from './bi-hooks/useBiLogger';
import { getStaticBiEventsFields } from './bi-hooks/useCommonBiEventsFields';
import { useEclipsePanorama } from './useEclipsePanorama';

/** errorType on 17:2236 for a failed query the page recovered from. */
export const HANDLED_QUERY_ERROR_TYPE = 'Handled';

/**
 * For queries with `useErrorBoundary: false`, which fall back instead of
 * showing the error page and so are never reported otherwise. Returns a
 * function for the query's `onError`:
 *
 *   onError: (error) => reportQueryError('getAiPlanContent', error)
 *
 * It reports to Panorama and 17:2236 with `errorType: 'Handled'`.
 */
export const useReportQueryError = () => {
  const {
    reportError
  } = useEclipsePanorama();
  const {
    biLogger
  } = useBiLogger();
  return (queryName, error) => {
    var _response;
    if (!(error instanceof Error)) {
      return;
    }
    const requestId = (_response = error.response) == null ? void 0 : _response.requestId;
    try {
      reportError(error, {
        tags: {
          queryName,
          errorType: HANDLED_QUERY_ERROR_TYPE,
          requestId
        }
      });
      biLogger == null || biLogger.report(packagePickerErrorSrc17Evid2236({
        ...getStaticBiEventsFields(),
        errorType: HANDLED_QUERY_ERROR_TYPE,
        errorMessage: `[${queryName}] ${error.message}`,
        requestId
      }));
    } catch {
      // Reporting is best-effort; the component's fallback still renders.
    }
  };
};
//# sourceMappingURL=useReportQueryError.js.map